export function camelCaseToSpaceSeparated(text: string) {
  if (!text) return '';

  return text.replace(/([a-z])([A-Z])/g, '$1 $2').trim();
}
